export default "https://cdn-static-staging.gokick.com/assets/98f5e78fc13494034d6569c4b787741d65d3002e/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";